import React from "react";
import EventDetail from "./EventDetail";

function EventDetailPage(props) {
  return (
    <>
      <EventDetail pageTitle={props.pageTitle} />
    </>
  );
}

export default EventDetailPage;
